import React from 'react';
import { PageLoader } from 'src/lib/PageLoader';

export const AsyncCareersPage = ({ ...props }): JSX.Element => (
  <PageLoader
    id='src/pages/CareersPage/Careers'
    componentImport={async () => (await import('src/pages/CareersPage/Careers'))}
    head={() => async () => {
      return {
        title: 'Careers',
        description: 'View our currently open positions, apply, and start your career with Rock Island Auction',
      };
    }}
    {...props}
  />
);
